import styled from '@emotion/styled'

export const ContactInfoFormWrapper = styled.div`
  position: relative;
`
